// import '../util/scrollToNextSection';
// import {animateOnScroll, animate} from "../utils/animate";

export default {
    init($) {

        // JavaScript to be fired on the home page
    },
    finalize($) {
        const singleSliderBase = {
            item        : 1,
            auto        : true,
            loop        : true,
            pause       : 5000,
            pager       : false,
            controls    : false,
            slideMargin : 0,
        };

        $('#lightSliderSingle').lightSlider(Object.assign({}, singleSliderBase, {}));

        setTimeout(function () {
            $('#lightSliderHero').lightSlider(Object.assign({}, singleSliderBase, {
                controls : true,
            }));
            $('#lightSliderQuotes').lightSlider(Object.assign({}, singleSliderBase, {
                autoHeight : true,
            }));
        }, 1500);
    },
};
